import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspaceWatermarkTemplates } from '../../fragments/generated/watermark_templates';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWorkspaceWatermarkTemplatesQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type GetWorkspaceWatermarkTemplatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspace?: { __typename?: 'Workspace', id: string, watermarkTemplates?: { __typename?: 'WatermarkTemplateConnection', totalCount: number, nodes: Array<{ __typename?: 'WatermarkTemplate', id: string, deletedAt?: string | null, inUse: boolean, name: string, blocks?: Array<{ __typename?: 'WatermarkBlock', alpha?: number | null, fontSize?: Types.WatermarkFontSize | null, name?: string | null, position?: Types.WatermarkPosition | null, positionReferencePoint?: Types.WatermarkPosition | null, positionX?: number | null, positionY?: number | null, rotation?: number | null, scrollText?: Types.WatermarkScrollText | null, textAlignment?: Types.WatermarkTextAlignment | null, textColor?: string | null, textShadow?: boolean | null, dataPoints?: Array<{ __typename?: 'WatermarkDataPointCustomText', value?: string | null } | { __typename: 'WatermarkDataPointEmail' } | { __typename: 'WatermarkDataPointIpAddress' } | { __typename: 'WatermarkDataPointTimestamp' } | { __typename: 'WatermarkDataPointUserInput' } | { __typename: 'WatermarkDataPointUserName' } | null> | null } | null> | null }> } | null } | null } | null };


export const GetWorkspaceWatermarkTemplates = /*#__PURE__*/ gql`
    query GetWorkspaceWatermarkTemplates($workspaceId: ID!) {
  account(by: {workspaceId: $workspaceId}) {
    id
    workspace(workspaceId: $workspaceId) {
      id
      ...WorkspaceWatermarkTemplates
    }
  }
}
    ${WorkspaceWatermarkTemplates}` as unknown as DocumentNode<GetWorkspaceWatermarkTemplatesQuery, GetWorkspaceWatermarkTemplatesQueryVariables>;

          

          export const useGetWorkspaceWatermarkTemplatesQuery = (options?:QueryHookOptions<GetWorkspaceWatermarkTemplatesQuery, GetWorkspaceWatermarkTemplatesQueryVariables>) => useQuery(GetWorkspaceWatermarkTemplates, options);

          

          export type GetWorkspaceWatermarkTemplatesQueryOptions = QueryHookOptions<GetWorkspaceWatermarkTemplatesQuery, GetWorkspaceWatermarkTemplatesQueryVariables>;

          

          export const useGetWorkspaceWatermarkTemplatesLazyQuery = (options?:LazyQueryHookOptions<GetWorkspaceWatermarkTemplatesQuery, GetWorkspaceWatermarkTemplatesQueryVariables>) => useLazyQuery(GetWorkspaceWatermarkTemplates, options);

          

          export type GetWorkspaceWatermarkTemplatesQueryResult = ReturnType<typeof useGetWorkspaceWatermarkTemplatesQuery>;

          
